<div class="transport-order-page" *ngIf="orderDetail; else loadingOrError">
    <!-- Main Card Content -->
    <div class="main-card">
        <!-- Order Header -->
        <div class="order-header">
            <div class="header-content">
                <div class="header-left">
                    <button
                        mat-icon-button
                        (click)="goBack()"
                        aria-label="Volver"
                        class="back-btn"
                    >
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div class="order-title">
                        <p>Orden de Transporte</p>
                        <h1>Nro. O/T {{ padNumber(orderDetail.order.Id) }}</h1>
                    </div>
                    <span
                        class="status-badge"
                        [ngClass]="getStatusClass(orderDetail.order.StatusName)"
                    >
                        {{ orderDetail.order.StatusName }}
                    </span>
                </div>
            </div>
        </div>

        <div class="content-area">
            <!-- Operational Info Grid (Merged) -->
            <div class="info-grid">
                <!-- Row 1 -->
                <div class="info-card">
                    <span class="label">Nro. Reserva</span>
                    <p class="value">{{ orderDetail.order.BookingNumber }}</p>
                </div>
                <div class="info-card">
                    <span class="label">Cliente</span>
                    <p class="value">{{ orderDetail.order.CustomerName }}</p>
                </div>
                <div class="info-card">
                    <span class="label">Exportador</span>
                    <p class="value">{{ orderDetail.order.ShipperName }}</p>
                </div>
                <div class="info-card">
                    <span class="label">Consignatario</span>
                    <p class="value">
                        {{ orderDetail.order.ConsigneeName || '-' }}
                    </p>
                </div>

                <!-- Row 2 -->
                <div class="info-card">
                    <span class="label">Ref. Cliente</span>
                    <p class="value">
                        {{ orderDetail.order.CustomerReference || '-' }}
                    </p>
                </div>
                <div class="info-card">
                    <span class="label">Viaje</span>
                    <p class="value">
                        {{ orderDetail.order.CarrierVesselVoyage }}
                    </p>
                </div>
                <div class="info-card">
                    <span class="label">Tipo Embarque</span>
                    <p class="value with-icon">
                        <mat-icon
                            [class.text-amber]="isPallet"
                            [class.text-blue]="isContainer"
                        >
                            {{ isPallet ? 'inventory_2' : 'directions_boat' }}
                        </mat-icon>
                        {{ orderDetail.order.TypeOfShipmentName }}
                    </p>
                </div>
                <div class="info-card">
                    <span class="label">POD</span>
                    <p class="value">
                        {{ orderDetail.order.PortOfDischargeName || '-' }}
                    </p>
                </div>

                <!-- Row 3 (Merged Contract & Carrier) -->
                <div class="info-card">
                    <span class="label">Contrato Cliente</span>
                    <p class="value">
                        {{ orderDetail.order.CustomerContractName || '-' }}
                    </p>
                </div>
                <div class="info-card">
                    <span class="label">Naviera</span>
                    <p class="value">{{ orderDetail.order.CarrierFullName }}</p>
                </div>
            </div>

            <!-- Ports Flow Section -->
            <div class="ports-section">
                <div class="flow-container">
                    <!-- Planta Destino -->
                    <div class="port-item">
                        <div class="icon-label">
                            <mat-icon class="text-emerald">place</mat-icon>
                            <span>Planta Destino</span>
                        </div>
                        <p class="port-name">
                            {{
                                orderDetail.items[0]
                                    .FirstDispatchPlantLocationName || '-'
                            }}
                        </p>
                        <p class="terminal-name">
                            {{
                                orderDetail.items[0].FirstDispatchPlantName ||
                                    '-'
                            }}
                        </p>
                    </div>

                    <!-- Arrow -->
                    <div class="flow-arrow">
                        <mat-icon class="truck-icon">local_shipping</mat-icon>
                        <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                    </div>

                    <!-- Punto Final (POL) -->
                    <div class="port-item">
                        <div class="icon-label">
                            <mat-icon class="text-blue">place</mat-icon>
                            <span>Punto Final</span>
                        </div>
                        <p class="port-name">
                            {{ orderDetail.order.PortOfLoadingName }}
                        </p>
                        <p class="terminal-name">
                            {{ orderDetail.order.TerminalName || '-' }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Financial & Service Info (Moved and Simplified) -->
            <div class="financial-section">
                <div
                    class="section-header"
                    style="margin-top: 0; margin-bottom: 1rem"
                >
                    <div class="icon-box blue">
                        <mat-icon>monetization_on</mat-icon>
                    </div>
                    <h2>Información Financiera</h2>
                </div>

                <div class="financial-grid">
                    <div class="info-card">
                        <span class="label">Costo Neto</span>
                        <p class="value font-mono">
                            {{ removeClpSuffix(orderDetail.order.NetValue) }}
                        </p>
                    </div>
                    <div class="info-card">
                        <span class="label">Extra Costos</span>
                        <p class="value font-mono text-amber">
                            {{ removeClpSuffix(orderDetail.order.ExtraCosts) }}
                        </p>
                    </div>
                    <div class="info-card">
                        <span class="label">Total Estimado</span>
                        <p class="value font-mono font-bold text-emerald">
                            {{
                                orderDetail.order.TotalValue
                                    ? removeClpSuffix(
                                          orderDetail.order.TotalValue
                                      )
                                    : getTotalDisplay()
                            }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Financial Section (Revisar campos reales en la interfaz/DTO, usando valores opcionales) -->
            <!-- Note: Assuming properties might exist or handled differently. Using mockup properties if defined in DTO, or hiding if not present -->
            <!-- Based on previous file reads, OrderDetailDto had standard fields. If financial fields are missing in backend, this part will be hidden or empty. -->
            <!-- Let's assume we want to show it if data exists in other objects or just structure it. -->
            <!-- The user provided code uses order.NetAmount etc. I will implement but hide with *ngIf based on available data or just show placeholders if fields match. -->
            <!-- NOTE: The provided DTO doesn't have NetAmount/SubTotal on the main order object in the earlier read definitions. -->
            <!-- However, ServiceOrders have financial data. I will implement the structure but it might be empty if backend doesn't send it on root. -->
            <!-- I will comment out the values binding if property doesn't exist to avoid build error, or check interface. -->

            <!-- FINANCIAL SECTION IMPLEMENTATION - Adapted from Service Orders Sum if Main Order doesn't have it, or just static structure -->
            <!-- Checking interface TransportOrder... it does NOT have NetAmount. The user's code was nextjs mockup. -->
            <!-- I will skip the financial section specific values for the Order if they are not in the DTO, -->
            <!-- OR I can sum up from ServiceOrders service to show something useful. -->

            <!-- Filter Section -->
            <div
                class="filter-section mb-6 flex justify-end"
                *ngIf="orderDetail.items && orderDetail.items.length > 0"
            >
                <mat-form-field appearance="outline" class="w-64">
                    <mat-label>Filtrar por Item</mat-label>
                    <mat-select [(ngModel)]="selectedItemId">
                        <mat-option value="all">Todos</mat-option>
                        <mat-option
                            *ngFor="let item of orderDetail.items"
                            [value]="item.Id"
                        >
                            {{
                                isPallet
                                    ? item.TruckLicensePlate || 'Sin Patente'
                                    : item.ContainerNumber || 'Sin Nro'
                            }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Containers Table -->
            <div
                class="section-container"
                *ngIf="filteredContainers.length > 0"
            >
                <div class="section-header">
                    <div class="icon-box blue">
                        <mat-icon>directions_boat</mat-icon>
                    </div>
                    <h2>Containers</h2>
                    <span class="count-badge blue">{{
                        filteredContainers.length
                    }}</span>
                </div>

                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th class="sticky-col">#</th>
                                <th>Estado</th>
                                <th>Nro. Contenedor</th>
                                <th>Sello</th>
                                <th>Tipo</th>
                                <th>Patente Camión</th>
                                <th>Patente Carro</th>
                                <th class="text-right">Tara (KG)</th>
                                <th>Depósito</th>
                                <th>Retiro Cruzado</th>
                                <th>Gate Out Dep. (Ant.)</th>
                                <th>Planta</th>
                                <!-- Origin -->
                                <th>POL</th>
                                <th>Planta Desp.</th>
                                <th>Fecha Cit.</th>
                                <th>Nro. Factura</th>
                                <th class="text-right">Costo (Neto)</th>
                                <th>Gate Out Dep. (Obs.)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let item of filteredContainers;
                                    let i = index
                                "
                            >
                                <td class="sticky-col font-bold">
                                    {{ i + 1 }}
                                </td>
                                <td>
                                    <span
                                        class="status-pill"
                                        [ngClass]="
                                            getStatusClass(item.ItemStatusName)
                                        "
                                    >
                                        {{ item.ItemStatusName || 'N/A' }}
                                    </span>
                                </td>
                                <td class="font-mono font-bold">
                                    {{ item.ContainerNumber || '-' }}
                                </td>
                                <td>{{ item.CarrierSealNumber || '-' }}</td>
                                <td>{{ item.TypeOfContainerName || '-' }}</td>
                                <td class="font-mono">
                                    {{ item.TruckLicensePlate || '-' }}
                                </td>
                                <td class="font-mono">
                                    {{ item.TrailerTruckLicensePlate || '-' }}
                                </td>
                                <td class="text-right font-mono">
                                    {{ item.ContainerTare || '-' }}
                                </td>
                                <td>{{ item.DepotName || '-' }}</td>
                                <td>
                                    {{
                                        item.CrossContainerWithdrawalIndicatorName ||
                                            '-'
                                    }}
                                </td>
                                <td>
                                    {{
                                        item.GateOutDepotInAdvanceIndicatorName ||
                                            '-'
                                    }}
                                </td>
                                <td>
                                    {{ item.FirstDispatchPlantName || '-' }}
                                </td>
                                <td>
                                    {{
                                        item.FirstDispatchPlantLocationName ||
                                            '-'
                                    }}
                                </td>
                                <td>
                                    {{ item.FirstDispatchPlantName || '-' }}
                                </td>
                                <td>
                                    {{
                                        item.FirstDispatchPlantCitationDate ||
                                            '-'
                                    }}
                                </td>
                                <td>
                                    {{
                                        item.InlandTransportProviderInvoiceNumber ||
                                            '-'
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        removeClpSuffix(
                                            item.InlandTransportProviderCostAmount
                                        )
                                    }}
                                </td>
                                <td>{{ item.RemarksGateOutDepot || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Pallets Table -->
            <div class="section-container" *ngIf="filteredPallets.length > 0">
                <div class="section-header">
                    <div class="icon-box amber">
                        <mat-icon>inventory_2</mat-icon>
                    </div>
                    <h2>Pallets</h2>
                    <span class="count-badge amber">{{
                        filteredPallets.length
                    }}</span>
                </div>

                <div class="table-wrapper">
                    <!-- Simplified table for pallets based on reference -->
                    <table>
                        <thead>
                            <tr>
                                <th class="sticky-col">#</th>
                                <th>Estado</th>
                                <th class="text-right">Cant. Plts</th>
                                <th>Patente Camión</th>
                                <th>Patente Carro</th>
                                <th>Planta Origen</th>
                                <th>POL</th>
                                <th>Fecha Cit.</th>
                                <th class="text-right">Costo Flete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let item of filteredPallets;
                                    let i = index
                                "
                            >
                                <td class="sticky-col">{{ i + 1 }}</td>
                                <td>
                                    <span
                                        class="status-pill"
                                        [ngClass]="
                                            getStatusClass(item.ItemStatusName)
                                        "
                                    >
                                        {{ item.ItemStatusName || 'N/A' }}
                                    </span>
                                </td>
                                <td class="text-right font-bold">
                                    {{ item.QuantityOfPallets || 0 }}
                                </td>
                                <td>{{ item.TruckLicensePlate || '-' }}</td>
                                <td>
                                    {{ item.TrailerTruckLicensePlate || '-' }}
                                </td>
                                <td>
                                    {{ item.FirstDispatchPlantName || '-' }}
                                </td>
                                <td>
                                    {{ orderDetail.order.PortOfLoadingName }}
                                </td>
                                <td>
                                    {{
                                        item.FirstDispatchPlantCitationDate ||
                                            '-'
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        removeClpSuffix(
                                            item.InlandTransportProviderCostAmount
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Service Orders Table -->
            <div
                class="section-container"
                *ngIf="filteredServiceOrders.length > 0"
            >
                <div class="section-header">
                    <div class="icon-box amber">
                        <!-- Reusing amber style for simplicity, or add receipt icon style -->
                        <mat-icon>receipt</mat-icon>
                    </div>
                    <h2>Órdenes de Servicio (Extra Costos)</h2>
                    <span class="count-badge amber">{{
                        filteredServiceOrders.length
                    }}</span>
                </div>

                <div class="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Servicio</th>
                                <th>Tipo</th>
                                <th>Categoría</th>
                                <th>
                                    @if (orderDetail.order.TypeOfShipmentName
                                    === 'Pallet') { Patente Camión } @else {
                                    Nro. Contenedor }
                                </th>
                                <th>Estado</th>
                                <th class="text-right">Cantidad</th>
                                <th class="text-right">Monto Neto</th>
                                <th class="text-right">IVA</th>
                                <th class="text-right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let so of filteredServiceOrders;
                                    let i = index
                                "
                            >
                                <td>{{ i + 1 }}</td>
                                <td>{{ so.ServiceName }}</td>
                                <td>{{ so.TypeOfServiceName }}</td>
                                <td>{{ so.CategoryOfServiceName }}</td>
                                <td class="font-mono">
                                    {{ so.ReferenceValue || '-' }}
                                </td>
                                <td>
                                    <span
                                        class="status-pill"
                                        [ngClass]="
                                            getStatusClass(so.StatusName)
                                        "
                                    >
                                        {{ so.StatusName }}
                                    </span>
                                </td>
                                <td class="text-right">{{ so.Quantity }}</td>
                                <td class="text-right">
                                    {{
                                        removeClpSuffix(
                                            so.UnitSellingPriceTotalNetAmount
                                        )
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        removeClpSuffix(
                                            so.UnitSellingPriceTotalVatAmount
                                        )
                                    }}
                                </td>
                                <td class="text-right font-bold text-amber">
                                    {{
                                        removeClpSuffix(
                                            so.UnitSellingPriceTotalPaymentAmount
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Agenda Section -->
            <div
                class="section-container"
                *ngIf="orderDetail.items && orderDetail.items.length > 0"
            >
                <div class="section-header agenda-header">
                    <div class="icon-box">
                        <i class="ti ti-calendar"></i>
                    </div>
                    <h2>Agenda</h2>
                </div>

                <!-- Timeline Grouped by Container/Item -->
                <div class="timeline-list">
                    <ng-container *ngFor="let item of filteredItems">
                        <div
                            class="timeline-card"
                            *ngIf="getTimelineEvents(item).length > 0"
                        >
                            <h3>
                                <i [class]="isPallet ? 'ti ti-truck' : 'ti ti-container'"></i>
                                {{
                                    isPallet
                                        ? 'Patente: ' +
                                          (item.TruckLicensePlate ||
                                              'Sin Patente')
                                        : 'Contenedor: ' +
                                          (item.ContainerNumber || 'Sin Nro')
                                }}
                            </h3>

                            <ul class="timeline">
                                <li
                                    class="timeline-item"
                                    [class.timeline-item-right]="i % 2 === 1"
                                    *ngFor="
                                        let event of getTimelineEvents(item);
                                        let i = index
                                    "
                                >
                                    <span class="dot"></span>
                                    <div class="date">
                                        {{ event.date }}
                                    </div>
                                    <div class="inner">
                                        <div class="event-icon">
                                            <i [class]="getEventIcon(event.title)"></i>
                                        </div>
                                        <div class="event-content">
                                            <h6>{{ i + 1 }}) {{ event.title }}</h6>
                                            <p
                                                class="event-location"
                                                *ngIf="event.assignedTo"
                                            >
                                                {{ event.assignedTo }}
                                            </p>
                                            <p
                                                class="event-description"
                                                *ngIf="event.description"
                                            >
                                                {{ event.description }}
                                            </p>
                                        </div>
                                        <div
                                            class="event-duration"
                                            *ngIf="event.duration"
                                        >
                                            <i class="ti ti-clock"></i>
                                            <span>Tiempo: {{ event.duration }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </ng-container>

                    <!-- Show message if no agenda events found -->
                    <div
                        *ngIf="filteredItems.length === 0 || !hasAgendaEvents()"
                        class="info-card text-center text-muted"
                    >
                        No hay eventos de agenda registrados para la selección
                        actual.
                    </div>
                </div>
            </div>
        </div>
        <!-- End Content Area -->
    </div>
    <!-- End Main Card -->
</div>
<!-- End Transport Order Page -->

<ng-template #loadingOrError>
    <div *ngIf="loading" class="loading-container">
        <p>Cargando detalle de la orden...</p>
    </div>
    <div *ngIf="error" class="error-container">
        <p>{{ error }}</p>
    </div>
</ng-template>
